module.exports = __webpack_public_path__ + "img/who-are-we.60cfd4c3.jpg";